export default __webpack_public_path__ + "static/media/Major Rune Stone of Berserker's Fury (V).dbb49031.jpg";